import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMAssetsClearSearch, ISCMAssetsClearDetail, ISCMAssetsClearStatistics, ISCMAssetsClearInsert, ISCMAssetsClearUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./assetsClearTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class AssetsClearService {
    async page(searchVo: ISCMAssetsClearSearch) {
        const apiUrl = "/assets/assets/page";
        return await httpRequest.post<IPage<ISCMAssetsClearDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMAssetsClearSearch) {
        const apiUrl = "/assets/assets/total";
        return await httpRequest.post<ISCMAssetsClearStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/assets/findById/${id}`
        return await httpRequest.get<ISCMAssetsClearDetail>(apiUrl)
    }
    async insert(insertVo: ISCMAssetsClearInsert) {
        const apiUrl = '/assets/assets/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMAssetsClearInsert) {
        const apiUrl = '/assets/assets/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async deleteImg(updateVo: any) {
        const apiUrl = '/assets/base/material/updateMaterialPhoto'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async export(searchVo: ISCMAssetsClearSearch) {
        const apiUrl = "/assets/assets/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }

    async print(id: string) {
        const apiUrl = `/assets/assets/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async GetprintTip(id: string) {
        const apiUrl = `/assets/assets/printLabelFour/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // 详情打印按钮
    async printGoodTip(value: any) {
        const apiUrl = `/assets/assets/printLabelFourList`;
        return await httpRequest.post<boolean>(apiUrl, value);
    }
    //资产明细查询接口
    async assetsListDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/assets/assets/detailsPage";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/assets/assets/receive/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
}

export const assetsClearService = new AssetsClearService();